/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle'
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes'
import { faLongArrowAltUp } from '@fortawesome/free-solid-svg-icons/faLongArrowAltUp'
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons/faPencilAlt'
import { faFont } from '@fortawesome/free-solid-svg-icons/faFont'
import { faEraser } from '@fortawesome/free-solid-svg-icons/faEraser'
import { faUndo } from '@fortawesome/free-solid-svg-icons/faUndo'
import { faRedo } from '@fortawesome/free-solid-svg-icons/faRedo'
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons/faPaperPlane'
import { faCamera } from '@fortawesome/free-solid-svg-icons/faCamera'
import { faFolderOpen } from '@fortawesome/free-solid-svg-icons/faFolderOpen'
import { faPhoneSlash } from '@fortawesome/free-solid-svg-icons/faPhoneSlash'
import { faPhone } from '@fortawesome/free-solid-svg-icons/faPhone'
import { faMicrophoneAlt } from '@fortawesome/free-solid-svg-icons/faMicrophoneAlt'
import { faMicrophoneAltSlash } from '@fortawesome/free-solid-svg-icons/faMicrophoneAltSlash'
import { faPen } from '@fortawesome/free-solid-svg-icons/faPen'
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus'
import { faShare } from '@fortawesome/free-solid-svg-icons/faShare'
import { faExpand } from '@fortawesome/free-solid-svg-icons/faExpand'
import { faCaretUp } from '@fortawesome/free-solid-svg-icons/faCaretUp'
import { faCaretDown } from '@fortawesome/free-solid-svg-icons/faCaretDown'
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons/faCalendarAlt'
import { faFilter } from '@fortawesome/free-solid-svg-icons/faFilter'
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons/faExternalLinkAlt'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons/faQuestionCircle'
import { faDollarSign } from '@fortawesome/free-solid-svg-icons/faDollarSign'
import { faCreditCard } from '@fortawesome/free-solid-svg-icons/faCreditCard'
import { faUserCircle } from '@fortawesome/free-solid-svg-icons/faUserCircle'
import { faPause } from '@fortawesome/free-solid-svg-icons/faPause'
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle'
import { faCompress } from '@fortawesome/free-solid-svg-icons/faCompress'
import { faVideo } from '@fortawesome/free-solid-svg-icons/faVideo'
import { faVideoSlash } from '@fortawesome/free-solid-svg-icons/faVideoSlash'
import { faBell } from '@fortawesome/free-solid-svg-icons/faBell'
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight'
import { faPlay } from '@fortawesome/free-solid-svg-icons/faPlay'
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons/faSyncAlt'
import { faCircle } from '@fortawesome/free-regular-svg-icons/faCircle'
import { faSquare } from '@fortawesome/free-regular-svg-icons/faSquare'
import { faPauseCircle } from '@fortawesome/free-regular-svg-icons/faPauseCircle'
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons/faCheckCircle'
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye'
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash'
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons/faArrowUp'
import classNames from 'classnames/bind'
import * as styles from './Icon.scss'
import Draw from './icons/draw.svg'
import Line from './icons/line.svg'
import Erase from './icons/erase.svg'
import Oval from './icons/oval.svg'
import Square from './icons/square.svg'
import Text from './icons/text.svg'
import Close from './icons/close.svg'
import Info from './icons/info.svg'
import Help from './icons/help.svg'

const cx = classNames.bind(styles)

const ICONS = {
  valid: faCheck,
  alert: faExclamationTriangle,
  warning: faTimes,
  circleRegular: faCircle,
  longArrowAltUp: faLongArrowAltUp,
  pencilAlt: faPencilAlt,
  squareRegular: faSquare,
  font: faFont,
  eraser: faEraser,
  undo: faUndo,
  redo: faRedo,
  paperPlane: faPaperPlane,
  camera: faCamera,
  folderOpen: faFolderOpen,
  caretUp: faCaretUp,
  caretDown: faCaretDown,
  phoneSlash: faPhoneSlash,
  phone: faPhone,
  plus: faPlus,
  microphone: faMicrophoneAlt,
  microphoneSlash: faMicrophoneAltSlash,
  pen: faPen,
  share: faShare,
  expand: faExpand,
  calendarAlt: faCalendarAlt,
  filter: faFilter,
  externalLinkAlt: faExternalLinkAlt,
  questionCircle: faQuestionCircle,
  dollarSign: faDollarSign,
  creditCard: faCreditCard,
  pause: faPause,
  pauseCircle: faPauseCircle,
  userCircle: faUserCircle,
  exclamationCircle: faExclamationCircle,
  compress: faCompress,
  video: faVideo,
  videoSlash: faVideoSlash,
  bell: faBell,
  chevronUp: faChevronUp,
  chevronDown: faChevronDown,
  chevronLeft: faChevronLeft,
  chevronRight: faChevronRight,
  times: faTimes,
  exclamationTriangle: faExclamationTriangle,
  checkCircle: faCheckCircle,
  play: faPlay,
  syncAlt: faSyncAlt,
  eye: faEye,
  eyeSlash: faEyeSlash,
  bars: faBars,
  arrowLeft: faArrowLeft,
  arrowUp: faArrowUp,
}

const SELF_ICONS = {
  draw: Draw,
  erase: Erase,
  line: Line,
  oval: Oval,
  square: Square,
  text: Text,
  close: Close,
  info: Info,
  help: Help,
}

const isStrokeIcon = name => {
  if (name === 'square') {
    return true
  }

  return false
}

interface IProps {
  name: string,
  size?: string,
}

const Icon: React.SFC<IProps> = ({ name, size }) => {
  const fontAwesomeIcon = ICONS[name]

  if (fontAwesomeIcon) {
    return <FontAwesomeIcon icon={fontAwesomeIcon} className={cx('root', size)} />
  }

  const SelfIcon = SELF_ICONS[name]

  if (SelfIcon) {
    return (
      <SelfIcon
        className={cx(
          'root',
          size,
          {
            fill: !isStrokeIcon(name),
            stroke: isStrokeIcon(name),
          },
        )}
      />
    )
  }

  return null
}

export default Icon
